(() => {
  const pending = new WeakSet();
  function fallbackClose(drawer) {
    const panel = drawer.querySelector('dialog');
    if (panel?.open) panel.close();
    drawer.removeAttribute('open');
    panel?.classList.remove('theme-drawer__dialog--opening','theme-drawer__dialog--closing');
    if (!document.querySelector('theme-drawer[open], dialog:modal')) {
      document.documentElement.removeAttribute('scroll-lock');
      document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
    }
    try {
      const ids = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter(id => id && id !== drawer.id);
      sessionStorage.setItem('theme-drawer-open',ids.join(','));
    } catch { /* The close action must work without session storage. */ }
  }
  async function closeDrawer(drawer) {
    if (!drawer) return;
    if (typeof drawer.close === 'function') {
      try { await drawer.close(); return; } catch { /* Native close remains available. */ }
    }
    fallbackClose(drawer);
  }
  document.addEventListener('click',async event => {
    const close = event.target.closest('#cart-drawer .theme-drawer__close-button');
    if (close) {
      event.preventDefault(); event.stopImmediatePropagation();
      await closeDrawer(close.closest('theme-drawer')); return;
    }
    const button = event.target.closest('[data-gm-shiprocket-checkout]');
    if (!button || button.disabled) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (pending.has(button)) return;
    pending.add(button); button.disabled = true; button.setAttribute('aria-busy','true');
    const drawer = button.closest('theme-drawer');
    try {
      await closeDrawer(drawer);
      const provider = window.shiprocketCheckoutEvents;
      if (typeof provider?.buyCart === 'function') {
        // Keep the original click event and provider context expected by Shiprocket.
        await provider.buyCart(event);
      } else {
        window.location.assign(button.dataset.checkoutUrl);
      }
    } catch {
      // A missing/failed third-party checkout must not strand the shopper.
      window.location.assign(button.dataset.checkoutUrl);
    } finally {
      pending.delete(button); button.disabled = false; button.removeAttribute('aria-busy');
    }
  },true);
})();
